<template>
    <div id="pie-chart">
        <v-chart :options="graph"/>
    </div>
</template>

<script>

import ECharts from 'vue-echarts'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/tooltip'


export default {
  name: 'pie',
  components: {'v-chart': ECharts},
  props: ['data','legendData'],

  data() {
    return {
      graph : {
        title : {
          text: 'Costos Producción',
          x:'left',
          top:34,
          padding:0
        },
        tooltip: {
          trigger: 'item',
          formatter: function (p) {
            const formatNumber = (value) => {
              if (value === null || value === undefined || value === '') return '';
              const num = Number(value);
              if (Number.isNaN(num)) return value;

              const isInt = Number.isInteger(num);
              return new Intl.NumberFormat('es-AR', {
                minimumFractionDigits: isInt ? 0 : 1,
                maximumFractionDigits: isInt ? 0 : 1,
              }).format(num);
            };

            const a = p?.seriesName ?? '';
            const b = p?.name ?? '';
            const c = formatNumber(p?.value);
            const d = formatNumber(p?.percent);

            return `${a} <br/>${b} : ${c} (${d}%)`;
          },
          position: 'inside'
        },
        textStyle: {
          fontFamily: 'Gotham',
          color: '#888',
          fontSize: 14,
        },
        series : [
          {
            name: 'Costos Producción (USD/Ha)',
            type: 'pie',
            radius : '55%',
            center: ['50%', '60%'],
            data:  [
              {value:this.data['Insumo_Sem'], name:'Semillas'},
              {value:this.data['Insumo_Herb'], name:'Herbicidas'},
              {value:this.data['Insumo_Insec'], name:'Insecticidas'},
              {value:this.data['Insumo_Fung'], name:'Fungicida'},
              {value:this.data['Insumo_Fert'], name:'Fertilizante'}
            ],
            label: {
              show: true,
              position: 'outside',
              formatter: (params) => {
                const num = Number(params?.percent);
                if (Number.isNaN(num)) return `${params.name} - ${params.percent}%`;

                const isInt = Number.isInteger(num);
                const pct = new Intl.NumberFormat('es-AR', {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                }).format(num);

                return `${params.name} - ${pct}%`;
              },
              fontSize: 12
            },
            labelLine: {
              show: true
            },
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
    }
  },
  methods: {
    /*formatHeader(index) {
      let partial = this.headers[index].replace(/_/g,' ');
      return partial.charAt(0).toUpperCase() + partial.slice(1) ;
    },*/
    modifyChartInMobileView() {
      if (window.screen.width < 600) {
        this.graph.series[0].radius = '30%';
        this.graph.title.top = 24;
        this.graph.series[0].center =  ['50%','40%'];
        this.graph.textStyle.fontSize = 10;
      }
    },
  },
  mounted(){
    this.modifyChartInMobileView();
  }
}
</script>
<style>
#pie-chart{height:200px; margin-top:-30px }
</style>



